import { useRef } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useLocomotiveScroll } from 'react-locomotive-scroll'
import Slider from 'react-slick'
import img1 from '../../assets/images/Bath.png';
import img2 from '../../assets/images/Bath-2.png';
import img3 from '../../assets/images/Bath-3.png';
import img4 from '../../assets/images/Kitchen.png';
import img5 from '../../assets/images/Kitchen-2.png';
import img6 from '../../assets/images/Kitchen-3.png';
import img7 from '../../assets/images/Kitchen-4.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Logo_v1 from '../../assets/svgComponents/kessel_logo_v1'
import Navigation from '../../components/nav';
import Footer from '../../components/footer';


function RefurbishmentPage(props) {
    const sliderRef = useRef(null);
    const { scroll } = useLocomotiveScroll()
    const handleScrollTo = (destination) =>{
        console.log(destination)
        scroll && scroll.scrollTo(destination, {
            duration: 1000, // optional duration of the scroll animation
            easing: [0.25, 0.46, 0.45, 0.94], // optional easing function
          });
    }

    var settings = {
        dots: false,
        infinite: true,
        speed: 300,
        prevArrow: false,
        nextArrow: false,
        arrows: false,
        autoSlidesToShow: true,
        variableWidth: true,
        swipeToSlide: true,
        slidesToScroll: 1,
      };

      const images = [
    { id: 1, url: img1, alt: 'Bath' },
    { id: 2, url: img2, alt: 'Bath path' },
    { id: 3, url: img3, alt: 'Bath hills' },
    { id: 4, url: img4, alt: 'Kitchen' },
    { id: 5, url: img5, alt: 'Kitchen' },
    { id: 6, url: img6, alt: 'Kitchen' },
    { id: 6, url: img7, alt: 'Kitchen' },
  ];
    const services = [
        "Retail Shop Fitting",
        "Joinery Works",
        "Furniture",
        "Painting and Decorating",
        "Partitions",
        "Tiling and Ceramics",
        "M&E Works",
        "Toilets & W/Cs",
        "Brand-Specific 'Refresh'",
        "License to Alter",
        "Landlord Approvals",
        "Occupied Premises",
        "Business as Usual",
        "Building Control Approvals",
        "Out of Hours Services",
        "Client-Specific Requests",
        "Projects from £5k to £500k"
    ];
  return (
    <>
        {/* <!DOCTYPE html><!--  This site was created in Webflow. https://www.webflow.com  -->
        <!--  Last Published: Tue Jun 13 2023 11:45:58 GMT+0000 (Coordinated Universal Time)  -->
        <html data-wf-page="64516d78bcac721f518797e0" data-wf-site="644ea99944c5360820a2262c" lang="en"> */}
        {/* <head>
        <meta charset="utf-8">
        <title>Kessel Construction | Real Estate and Commercial Construction Experts</title>
        <meta content="Discover the professionalism, expertise, and quality of Kessel Construction&#x27;s real estate and commercial construction projects. Trust our team of experts to bring your vision to life. Browse our portfolio and contact us today." name="description">
        <meta content="Kessel Construction | Real Estate and Commercial Construction Experts" property="og:title">
        <meta content="Discover the professionalism, expertise, and quality of Kessel Construction&#x27;s real estate and commercial construction projects. Trust our team of experts to bring your vision to life. Browse our portfolio and contact us today." property="og:description">
        <meta content="Kessel Construction | Real Estate and Commercial Construction Experts" property="twitter:title">
        <meta content="Discover the professionalism, expertise, and quality of Kessel Construction&#x27;s real estate and commercial construction projects. Trust our team of experts to bring your vision to life. Browse our portfolio and contact us today." property="twitter:description">
        <meta property="og:type" content="website">
        <meta content="summary_large_image" name="twitter:card">
        <meta content="width=device-width, initial-scale=1" name="viewport">
        <meta content="Webflow" name="generator">
        <link href="css/normalize.css" rel="stylesheet" type="text/css">
        <link href="css/webflow.css" rel="stylesheet" type="text/css">
        <link href="css/kssl.webflow.css" rel="stylesheet" type="text/css">
        <script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
        <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon">
        <link href="images/webclip.png" rel="apple-touch-icon">
        <link href="https://ksslc.com/" rel="canonical">
        </head> */}


        <div className="locomotive-scroll">
            <div className="div-block-7"></div>
            <Navigation />
            <section id="top" data-scroll-section="1" className="fs-styleguide-home main fitout">
                {/* <div className="page-padding project-main">
                    <img loading="lazy" width="300" alt="" className="project-main-image"/>
                    <div className="div-block-8">
                        <div className="text-block-2">Test</div>
                    </div>
                </div> */}
                <div className="page-padding main-40 fitout">
                    <div className="w-layout-grid grid">
                        <div id="w-node-f8920c95-7122-aea2-2563-df91807dc6d2-1c6a971a" className="div-block-9 project">
                            <h3 className="text-size-small"> We provide a full range of contracting services including:</h3>
                            {services.map((service, index) => (
                            <div key={index} className="flex items-start gap-3">
                            <span className="paragraph-3">✓ </span>
                            <span className="paragraph-3">{service}</span>
                            </div>
                            ))}
                            <div className="text-size-small">Contact us for further details.</div>
                        </div>
                    </div>
                </div>
            <div className="image-grid" > 
                {images.map((image) => (
                <div key={image.id} className="image-card">
                    <img src={image.url} alt={image.alt} />
                </div>
                ))}
            </div>
            </section>
            {/* <header id="services" data-scroll-section="1" className="section-layout1 brick gallery">
                <div className="wrapper-2 w-dyn-list">
                    {data.gallery === [] ? (
                        <div className="w-dyn-empty">
                        <div>No items found.</div>
                        </div>
                    ) : (
                         
                        <Slider {...settings} className="w-dyn-items" id="slider-id" ref={sliderRef}>
                            {data.gallery?.data?.map((uri, index) => (
                            <div role="listitem" key={index} className="item w-dyn-item">
                                <img src={uri.url} loading="lazy" alt="" className="image-13" />
                                <div className="image-13">
                                <div id="watermark" className="watermark">
                                    <Logo_v1 />
                                </div>
                                </div>
                            </div>
                            ))}
                        </Slider>
                    )}
                </div>
                <div className="slider-button-wrap-2">
                    <h1 className="heading-6"></h1>
                    <div className="arrow-wrapper-2">
                    <a onClick={() => sliderRef.current.slickPrev()} className="slider-button slider-prev w-inline-block">
                        <div className="rl_gallery21_arrow-icon w-embed"><svg width=" 100%" height=" 100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.81066 12.7499L12.5303 19.4696L11.4697 20.5303L2.93934 11.9999L11.4697 3.46961L12.5303 4.53027L5.81066 11.2499L20 11.2499L20 12.7499L5.81066 12.7499Z" fill="currentColor"></path>
                        </svg></div>
                    </a>
                    <a onClick={() => sliderRef.current.slickNext()} className="slider-button slider-next w-inline-block">
                        <div className="rl_gallery21_arrow-icon w-embed"><svg width=" 100%" height=" 100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.1893 11.2501L11.4697 4.53039L12.5303 3.46973L21.0607 12.0001L12.5303 20.5304L11.4697 19.4697L18.1893 12.7501H4V11.2501H18.1893Z" fill="currentColor"></path>
                        </svg></div>
                    </a>
                    </div>
                </div>
            </header> */}
            <Footer />
        </div>

    </>
  );
}

export default RefurbishmentPage;




